import { useState, useRef } from 'react'
import last from 'lodash/last'
import { DateUtil, TIME } from '@utils/dateUtil'
import { first } from 'lodash'
import { getStartAndEndDate } from '@utils'
import { RecurrenceT } from '@providers'

type UseDayPickerParamsT = {
  selectedDates: DateUtil[]
  defaultTimeFrom: string
  defaultTimeTo: string
  maxSelectedDays?: number
  allDay: boolean
  enableMultipleDays: boolean
  timezone: string
  isTimeChange: boolean
  onDateChange: (dates: DateUtil[]) => void
  validateDateTime: boolean
  recurrence?: RecurrenceT
}

type UseDayPickerT = (params: UseDayPickerParamsT) => {
  selectDaysRange: (day: DateUtil) => void
  selected: DateUtil[]
}

const useBookingDayPicker: UseDayPickerT = ({
  selectedDates,
  maxSelectedDays = 365,
  defaultTimeFrom,
  defaultTimeTo,
  allDay,
  enableMultipleDays,
  timezone,
  isTimeChange,
  validateDateTime,
  recurrence,
}) => {
  const isFirstTimeClickRef = useRef(true)
  // ======== hooks ========
  const [selected, setSelected] = useState(selectedDates)
  let dateValues = [...selected]

  // ======== handlers ========
  const selectDaysRange = (day: DateUtil) => {
    const dayDate = day

    setSelected((prevState) => {
      const lastDateElement = last(prevState) as DateUtil

      if (isFirstTimeClickRef.current || !enableMultipleDays) {
        isFirstTimeClickRef.current = !enableMultipleDays ? true : false

        return [day]
      }

      if (dayDate.isBefore(lastDateElement) || prevState.length > 1) {
        return [day]
      }

      if (DateUtil.diff(day, prevState[0], TIME.DAYS) < maxSelectedDays) {
        return [...prevState, day]
      }

      return [day]
    })
  }

  if (validateDateTime) {
    const firstDate = first(isTimeChange ? selectedDates : selected) as DateUtil
    const lastDate = last(isTimeChange ? selectedDates : selected) as DateUtil
    const startEndDates = getStartAndEndDate({
      startDate: firstDate,
      endDate: lastDate,
      allDay,
      defaultTimeFrom,
      defaultTimeTo,
      timezone,
      recurrence,
    })
    const { fromDate, toDate } = startEndDates
    dateValues = [fromDate, toDate]
  }

  return {
    selected: dateValues,
    selectDaysRange,
  }
}

export default useBookingDayPicker
